t = require('app/scripts/views/internal/teacup-with-helpers')('calendar_week')

module.exports = ->
  t.div '.week-horizontal-canvas'
